export const de = {
  // Navigation
  nav: {
    home: 'Startseite',
    findHairstylist: 'Suche',
    forum: 'Mädchenforum',
    about: 'Über uns',
  },
  // Header
  header: {
    account: 'Konto',
    connected: 'Verbunden',
    hairstylistAccount: 'Friseurkonto',
    clientAccount: 'Kundenkonto',
    viewProfile: 'Mein Friseurprofil ansehen',
    favorites: 'Meine Favoriten',
    reviews: 'Meine Bewertungen',
    myPosts: 'Meine Fragen',
    favoritePosts: 'Meine Lieblingsfragen',
    accountSettings: 'Mein Konto',
    logout: 'Abmelden',
    login: 'Anmelden',
    signup: 'Registrieren',
    addHairstylist: 'Ein Friseurprofil hinzufügen',
    messages: 'Nachrichten',
    iAmProvider: 'Ich biete einen Service an',
    dashboard: 'Dashboard',
    manageSubscription: 'Mein Abo verwalten',
    verifyEmail: 'E-Mail überprüfen',
    pendingEmails: 'Ausstehende E-Mails',
    dashboardAnalytics: 'Dashboard Analytics',
    chooseProviderType: 'Wählen Sie Ihren Dienstleistungstyp',
    editProfile: 'Mein Profil bearbeiten',
    upgradeToPro: 'Auf PRO upgraden',
  },
  // Home Page
  home: {
    heroTitle: 'Finde deine',
    heroAfro: 'Afro-Friseurin',
    heroClicks: '',
    heroSubtitle: 'und andere unabhängige Beauty-Profis',
    findButton: 'Ich suche einen Beauty-Profi!',
    signupButton: 'Ich biete einen Service an, melde mich an!',
    checking: 'Überprüfung...',
    lastProfiles: 'Zuletzt erstellte Profile',
    loading: 'Laden...',
    mockupAlt: 'App-Vorschau',
    existingProfileTitle: 'Du hast bereits ein Friseurprofil ✨',
    existingProfileMessage: 'Dein Konto ist bereits mit einem Profil im Verzeichnis verknüpft. Du kannst es direkt ansehen und bearbeiten.',
    viewMyProfile: 'Mein Profil ansehen',
    close: 'Schließen',
    statsText: '120+ Afro-Friseurinnen verzeichnet • Die größte Datenbank in Belgien',
    statsTextMobile: '120+ Afro-Friseurinnen in Belgien verzeichnet',
    newBadge: 'Neu bei Chérie Coiffer',
    newBadgeAriaLabel: 'Zur Sektion „Neu bei Chérie Coiffer“',
    providerHair: 'Frisur',
    providerNails: 'Nägel',
    providerMakeup: 'Make-up',
    providerEyelash: 'Wimpern',
    providerSale: 'Verkauf',
    selectProviderType: 'Welche Art von Service bietest du an?',
  },
  // Search Page
  search: {
    title: 'Eine Friseurin finden',
    filters: 'Filter',
    sort: 'Sortieren',
    sortBy: 'Sortieren nach',
    ascending: 'Aufsteigend',
    descending: 'Absteigend',
    photosAvailable: 'Fotos verfügbar',
    country: 'Land',
    allCountries: 'Alle Länder',
    noCountryFound: 'Kein Land gefunden',
    belgium: 'Belgien',
    france: 'Frankreich',
    switzerland: 'Schweiz',
    city: 'Stadt',
    cityPlaceholder: 'Nach einer Stadt suchen...',
    name: 'Name der Friseurin',
    namePlaceholder: 'Nach Namen suchen...',
    services: 'Leistungen',
    categories: 'Kategorien',
    kidsAccepted: 'Akzeptiert Kinder',
    menAccepted: 'Akzeptiert Männer',
    canTravel: 'Kann reisen',
    hasPhotos: 'Mit Fotos',
    results: 'Ergebnisse',
    noResults: 'Keine Ergebnisse gefunden',
    clearFilters: 'Filter zurücksetzen',
    apply: 'Anwenden',
    close: 'Schließen',
    generalInfo: 'Allgemeine Informationen',
    sortByDistance: 'Entfernung',
    sortByRating: 'Bewertung',
    sortByUpdated: 'Zuletzt aktualisiert',
    sortByCreated: 'Erstellungsdatum',
    refineSearch: 'Suche verfeinern',
    searchByCityService: 'Nach Stadt, Service suchen...',
    searching: 'Suche läuft…',
    removeCity: '{city} entfernen',
    coiffesChildren: 'Frisiert Kinder',
    coiffesMen: 'Frisiert Männer',
    canTravelLabel: 'Kann reisen',
    photosAvailableLabel: 'Fotos verfügbar',
    sortDefault: 'Standard',
    sortDistance: 'Entfernung',
    sortRating: 'Bewertungen',
    sortAlphabetical: 'Alphabetische Reihenfolge',
    sortCreatedAt: 'Erstellungsdatum',
    sortAscending: 'Aufsteigend sortieren',
    sortDescending: 'Absteigend sortieren',
    expand: 'Erweitern',
    collapse: 'Reduzieren',
    serviceTypes: 'Leistungsarten',
    loadingCategories: 'Kategorien werden geladen…',
    reset: 'Zurücksetzen',
    otherServices: 'Andere Leistungen',
    viewList: 'Liste',
    viewMap: 'Karte',
    activeFilter: 'aktiver Filter',
    youAreProvider: 'Bist du {provider}?',
    signupHere: 'Hier anmelden.',
    found: 'gefunden',
    foundSingular: 'gefunden',
    providers: 'Dienstleister',
    provider: 'Dienstleister',
    providerRegistration: 'Dienstleister-Registrierung',
    allResultsShown: 'Du hast alles gesehen ✨',
    profileNotPublished: 'Dein Profil ist noch nicht veröffentlicht. Aktiviere dein Abonnement, um sichtbar zu werden.',
    activateProfile: 'Mein Profil aktivieren',
  },
  // Hairstylist Card
  card: {
    canTravel: '(kann reisen)',
    photosAvailable: 'Fotos verfügbar',
    photos: 'Fotos',
    contact: 'Kontakt',
    viewProfile: 'Profil ansehen',
  },
  // Hairstylist Detail
  detail: {
    back: 'Zurück',
    addToFavorites: 'Zu Favoriten hinzufügen',
    removeFromFavorites: 'Aus Favoriten entfernen',
    contact: 'Kontakt',
    services: 'Leistungen',
    description: 'Beschreibung',
    gallery: 'Fotogalerie',
    reviews: 'Kundenbewertungen',
    rating: 'Bewertung',
    noReviews: 'Noch keine Bewertungen',
    writeReview: 'Eine Bewertung schreiben',
    editReview: 'Meine Bewertung bearbeiten',
    deleteReview: 'Meine Bewertung löschen',
    reviewPlaceholder: 'Schreibe deine Bewertung hier...',
    submitReview: 'Veröffentlichen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    save: 'Speichern',
    freeProfile: 'Kostenloses Profil (begrenzt)',
    proProfile: 'PRO-Profil',
    emptyState: 'Wähle eine Karte, um die Details zu sehen',
    generalInfo: 'Allgemeine Informationen',
    profileName: 'Profilname',
    notSpecified: 'Nicht angegeben',
    deleteProfile: 'Profil löschen',
    mainCity: 'Hauptstadt',
    citiesServed: 'Bediente Städte',
    presentation: 'Vorstellung',
    coordinates: 'Kontaktdaten',
    primaryContact: 'Primäres soziales Netzwerk',
    photos: 'Fotos',
    profilePhoto: 'Profilfoto',
    galleryPhoto: 'Galerie',
    servicesOffered: 'Angebotene Leistungen',
    loginToReview: 'Melde dich an, um eine Bewertung zu schreiben',
    giveReview: 'Bewertung schreiben',
    confirmDeleteReview: 'Möchtest du deine Bewertung wirklich löschen?',
    deleting: 'Wird gelöscht...',
    anonymousUser: 'Anonymer Nutzer',
    yourReview: '(Deine Bewertung)',
    unknownDate: 'Unbekanntes Datum',
    identificationCode: 'Identifikationscode:',
    prevPhoto: 'Vorheriges Foto',
    nextPhoto: 'Nächstes Foto',
    errorDeleteProfile: 'Fehler beim Löschen des Profils.',
    errorDelete: 'Fehler beim Löschen',
  },
  // Posts
  posts: {
    title: 'Mädchenforum',
    subtitle: 'Hier kannst du Fragen stellen, deine Erfahrungen teilen und anderen helfen.',
    createPost: 'Eine Frage erstellen',
    askQuestion: '+ Eine Frage stellen',
    editPost: 'Frage bearbeiten',
    deletePost: 'Frage löschen',
    noPosts: 'Noch keine Fragen',
    writeComment: 'Einen Kommentar schreiben',
    addComment: 'Einen Kommentar hinzufügen',
    commentPlaceholder: 'Einen Kommentar schreiben...',
    publish: 'Veröffentlichen',
    seeMoreComments: 'Die {count} vorherigen Kommentare ansehen',
    seeLessComments: 'Weniger anzeigen',
    addPhotos: 'Fotos hinzufügen',
    titlePlaceholder: 'Titel deiner Frage',
    contentPlaceholder: 'Inhalt deiner Frage...',
    loading: 'Laden...',
  },
  // Profile
  profile: {
    title: 'Mein Profil',
    favorites: 'Meine Favoriten',
    reviews: 'Meine Bewertungen',
    myPosts: 'Meine Fragen',
    favoritePosts: 'Meine Lieblingsfragen',
    noFavorites: 'Du hast noch keine Favoriten',
    noReviews: 'Du hast noch keine Bewertungen geschrieben',
    noPosts: 'Du hast noch keine Fragen erstellt',
    unpublishedTitle: 'Profil nicht veröffentlicht',
    unpublishedMessage: 'Dein Profil ist noch nicht auf der Plattform sichtbar. Schließe deine Zahlung ab, um es zu veröffentlichen.',
    signInToActivate: 'Melde dich an, um dein Profil zu aktivieren',
    signInToActivateText: 'Du hast eine E-Mail zur Profilaktivierung erhalten. Melde dich an, um fortzufahren.',
    finalizePayment: 'Zahlung abschließen',
  },
  // Payment
  payment: {
    title: 'Steigere deine berufliche Sichtbarkeit',
    subtitle: 'Wähle den Plan, der zu dir passt',
    freeTitle: 'Kostenloses Profil',
    freeSubtitle: 'Ideal, um sichtbar zu werden, mit begrenzten Funktionen.',
    proTitle: 'PRO-Profil',
    proSubtitle: 'Vollversion des Profils, um deine Sichtbarkeit zu steigern.',
    popular: 'Am beliebtesten',
    price: '{price}/Monat',
    perMonth: '/Monat',
    free: 'Kostenlos',
    createFree: 'Kostenlos starten',
    activatePro: 'Mein Abonnement aktivieren',
    freeNote: 'Bleibe so lange kostenlos, wie du willst.',
    priceProtection: 'Prototyp-Preis: Solange du abonniert bleibst, steigt dein Tarif nie.',
    creating: 'Wird erstellt...',
    redirecting: 'Weiterleitung...',
    successTitle: 'Profil erfolgreich erstellt!',
    successMessage: 'Herzlichen Glückwunsch! Dein kostenloses Profil wurde erstellt. Du kannst jetzt in unserem Verzeichnis sichtbar werden.',
    viewProfile: 'Mein Profil ansehen',
    backHome: 'Zurück zur Startseite',
    errorMissingData: 'Profil kann nicht erstellt werden: Profildaten fehlen. Bitte starte die Registrierung erneut.',
    errorPaymentData: 'Zahlung kann nicht gestartet werden: Profildaten fehlen. Bitte starte die Registrierung erneut.',
    errorEmail: 'Zahlung kann nicht gestartet werden: Die E-Mail-Adresse des Kontos fehlt.',
    errorCheckout: 'Fehler beim Erstellen der Zahlungssitzung. Bitte versuche es erneut.',
    errorProfileCreation: 'Fehler beim Erstellen des Profils',
    feature1: 'Sichtbar im Verzeichnis',
    feature2: 'Name + Stadt + Leistungen sichtbar',
    feature3: 'Vollständige Fotogalerie',
    feature4: 'Kundenbewertungen sichtbar',
    feature5: 'Durchschnittliche Bewertung angezeigt',
    feature6: 'Priorität in den Suchergebnissen',
    feature7: 'Zugang zu einem einfachen Profil',
    feature8: 'Verifiziertes PRO-Abzeichen',
    feature9: 'Prioritätssupport',
    feature10: 'Möglichkeit, jederzeit auf PRO zu upgraden',
    // Seite 3 – Konto erstellt, PRO-Option
    successAccountCreated: 'Dein Konto wurde erstellt! 🎉',
    successSubtitle: 'Du kannst die Plattform bereits frei nutzen.',
    successProIntro: 'Willst du mehr Sichtbarkeit? Entdecke die PRO-Option:',
    proCardTitle: 'PRO-Profil – 9,99 €/Monat',
    proCardSubtext: 'Sofortiger Sichtbarkeits-Boost',
    proFeaturePriority: 'Immer Priorität in den Suchergebnissen',
    proFeatureGallery: 'Fotogalerie für alle sichtbar',
    proFeatureReviews: 'Bewertungen & Sterne sichtbar',
    proFeatureDashboard: 'Dashboard & Statistiken',
    proFeatureServices: 'Detaillierte Leistungsliste',
    proFeatureCancel: 'Jederzeit kündbar',
    goProButton: 'Jetzt zu PRO',
    securityText: 'Sichere Zahlung (SSL & Stripe) – Keine versteckten Gebühren',
    skipUpgrade: 'Nein danke, bei FREE bleiben',
    errorProfileNotFound: 'Fehler: Profil nicht gefunden. Bitte starte die Registrierung erneut.',
    errorUserNotConnected: 'Fehler: Benutzer nicht verbunden.',
    signInToActivate: 'Melde dich an, um dein Profil zu aktivieren',
    signInToActivateText: 'Du hast eine E-Mail zur Profilaktivierung erhalten. Melde dich mit deinem Konto an, um fortzufahren.',
    signIn: 'Anmelden',
    errorStripeNotConfigured: 'Stripe ist noch nicht konfiguriert. Bitte REACT_APP_STRIPE_PUBLISHABLE_KEY setzen oder STRIPE_PUBLISHABLE_KEY in PaymentPage.jsx ersetzen.',
    errorStripeInit: 'Stripe konnte nicht initialisiert werden. Bitte stelle sicher, dass das Skript https://js.stripe.com/v3 geladen ist.',
    errorRedirectStripe: 'Fehler bei der Weiterleitung zu Stripe. Bitte versuche es erneut.',
    // Subscription Success Page
    subscriptionActivated: 'Abonnement aktiviert',
    subscriptionActivatedSubtitle: 'Dein Profil ist jetzt im Verzeichnis sichtbar. Kundinnen können dich finden, liken und Bewertungen hinterlassen 💗',
    subscriptionActiveStatus: 'Abonnement: AKTIV',
    subscriptionDetails: 'Abonnement-Details',
    plan: 'Plan:',
    professionalPlan: 'Professionelles Abonnement — 9,99 €/Monat',
    autoRenewal: 'Automatische Verlängerung:',
    enabled: 'Aktiviert',
    nextInvoice: 'Nächste Rechnung:',
    manageSubscription: 'Mein Abonnement verwalten',
    nextSteps: 'Die nächsten Schritte',
    completeProfile: 'Vervollständige dein Profil',
    completeProfileDescription: 'Füge mehr Details hinzu, um mehr Kundinnen anzuziehen',
    addPhotos: 'Fotos hinzufügen',
    addPhotosDescription: 'Zeige deine besten Kreationen in deiner Galerie',
    addPhotosButton: 'Fotos hinzufügen',
    inviteReviews: 'Lade deine Kundinnen ein, eine Bewertung zu hinterlassen',
    inviteReviewsDescription: 'Teile den Link zu deinem Profil, um Bewertungen zu erhalten',
    copyReviewLink: 'Meinen Bewertungslink kopieren',
    linkCopied: 'Link in die Zwischenablage kopiert!',
    communityMessage: 'Du gehörst jetzt zur Chérie Coiffer Community 💜',
    proudMessage: 'Wir sind so stolz, dich bei uns zu haben.',
    ifYouHaveQuestion: 'Wenn du eine Frage hast:',
    accessStylistSpace: 'Zu meinem Stylisten-Bereich →',
    germanMandatoryTitle1: 'Glückwunsch, dein Profil ist erstellt!',
    germanMandatoryTitle2: 'Schließe deine Registrierung ab',
    germanMandatorySubtitle: 'Die Zahlung ist erforderlich, um dein Profil auf der Plattform zu veröffentlichen',
    germanReadyTitle: 'Fast geschafft!',
    germanReadySubtitle: 'Aktiviere dein Profil, um auf der Karte zu erscheinen und für Kunden sichtbar zu sein.',
    germanPreviewLabel: 'So werden dich Kunden sehen',
    germanProVisibility: 'PRO-Sichtbarkeit',
    germanEarlyAccess: 'Early-Access-Preis. Jederzeit kündbar. Keine versteckten Gebühren.',
    germanBenefitMap: 'Auf der Stadtkarte erscheinen',
    germanBenefitSearch: 'Nach Service auffindbar sein',
    germanBenefitPhotos: 'Fotos & Bewertungen anzeigen',
    germanBenefitStats: 'Zugang zu deinen Statistiken',
    germanActivateButton: 'Profil aktivieren',
    germanActivateNote: 'Die meisten Stylistinnen aktivieren innerhalb von 2 Minuten.',
    paywallPreviewLabel: 'Vorschau deines öffentlichen Profils',
    paywallCtaGoLive: 'Mein Profil jetzt aktivieren',
    paywallPillRecommended: 'Empfohlen',
    paywallMicrocopy: 'Jederzeit kündbar · Keine versteckten Gebühren',
    finalizePay: 'Abschließen und bezahlen',
    proFeatureVerifiedBadge: 'Verifiziertes PRO-Abzeichen',
    proFeatureSearchable: 'Kunden können dich nach Stadt und Service finden',
  },
  // Account Settings
  account: {
    title: 'Mein Konto',
    accountInfo: 'Meine Informationen',
    username: 'Benutzername',
    email: 'E-Mail',
    creationDate: 'Erstellungsdatum',
    actions: 'Aktionen',
    changePassword: 'Mein Passwort ändern',
    deleteAccount: 'Mein Konto löschen',
    subscription: 'Mein Abonnement',
    subscriptionActive: 'Aktives Abonnement',
    subscriptionInactive: 'Kein aktives Abonnement',
    deleteWarning: 'Warnung',
    deleteWarningMessage: 'Wenn du dein Konto löschst und ein aktives Abonnement hast, wird es gekündigt und du kannst nicht mehr auf dein PRO-Profil zugreifen.',
    confirmDelete: 'Löschung bestätigen',
    cancel: 'Abbrechen',
    passwordModal: {
      title: 'Mein Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Neues Passwort bestätigen',
      change: 'Ändern',
      cancel: 'Abbrechen',
    },
  },
  // Common
  common: {
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    search: 'Suchen',
    filter: 'Filtern',
    clear: 'Löschen',
    submit: 'Senden',
    confirm: 'Bestätigen',
    notSpecified: 'Nicht angegeben',
  },
  // Chat
  chat: {
    button: 'Chat',
    title: 'Chatte mit uns',
    subtitle: 'Wir antworten normalerweise innerhalb von 24 Stunden',
    namePlaceholder: 'Dein Name',
    emailPlaceholder: 'Deine E-Mail',
    startChat: 'Konversation starten',
    messagePlaceholder: 'Tippe deine Nachricht...',
    emptyState: 'Starte die Konversation! 👋',
    close: 'Schließen',
  },
  // Auth Modal
  auth: {
    login: 'Anmelden',
    signup: 'Registrieren',
    resetPassword: 'Passwort zurücksetzen',
    username: 'Benutzername',
    usernamePlaceholder: 'Z.B: marie_braids78',
    email: 'E-Mail',
    emailOrUsername: 'E-Mail oder Benutzername',
    emailPlaceholder: 'Z.B: marie@example.com',
    emailOrUsernamePlaceholder: 'Z.B: marie_braids78 oder marie@mail.com',
    password: 'Passwort',
    passwordPlaceholder: 'Mindestens 6 Zeichen',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Gib dein Passwort erneut ein',
    forgotPassword: 'Passwort vergessen?',
    sendLink: 'Link senden',
    connect: 'Anmelden',
    signupButton: 'Registrieren',
    noAccount: 'Noch kein Konto? Registrieren',
    hasAccount: 'Bereits ein Konto? Anmelden',
    loading: 'Laden...',
    sending: 'Wird gesendet...',
    resendLink: 'Link erneut senden',
    resetEmailSent: 'Eine E-Mail zum Zurücksetzen des Passworts wurde dir gesendet. Bitte überprüfe dein Postfach.',
    verificationEmailResent: 'Bestätigungs-E-Mail erneut gesendet! Bitte überprüfe dein Postfach.',
    pleaseEnterEmail: 'Bitte gib deine E-Mail-Adresse ein.',
    usernameRequired: 'Benutzername ist erforderlich.',
    usernameInvalid: 'Benutzername darf nur Buchstaben, Zahlen, Bindestriche (-), Unterstriche (_) und Punkte (.) enthalten.',
    emailInvalid: 'Die E-Mail-Adresse ist nicht gültig. Bitte gib eine gültige E-Mail-Adresse ein.',
    passwordMinLength: 'Passwort muss mindestens 6 Zeichen enthalten.',
    passwordsDontMatch: 'Passwörter stimmen nicht überein.',
    usernameTaken: 'Dieser Benutzername ist bereits vergeben. Bitte wähle einen anderen.',
    emailTaken: 'Diese E-Mail wird bereits verwendet. Bitte melde dich an oder verwende eine andere E-Mail.',
    errorOccurred: 'Ein Fehler ist aufgetreten',
    networkError: 'Verbindungsproblem. Prüfen Sie Ihre Internetverbindung (WLAN oder Mobilfunk) und versuchen Sie es erneut.',
    verificationEmailError: 'Fehler beim Senden der Bestätigungs-E-Mail.',
  },
  // Language
  language: {
    french: 'Français',
    english: 'English',
    german: 'Deutsch',
    dutch: 'Nederlands',
  },
  // Signup Page
  signup: {
    alreadyHairstylistTitle: 'Du hast bereits ein Friseurprofil ✨',
    alreadyHairstylistMessage: 'Dein Konto ist bereits mit einem Profil im Verzeichnis verknüpft. Du kannst es direkt ansehen oder bearbeiten.',
    viewMyProfile: 'Mein Profil ansehen',
    welcomeTitle: 'Willkommen, Schöne!',
    welcomeSubtitle: 'Vervollständige dieses Formular, um unserem Verzeichnis beizutreten.',
    chatWelcomeMessage: 'Willkommen bei Chérie Coiffer! 💜 Danke, dass du unserer Friseurinnen-Community beigetreten bist. Bei Fragen antworte einfach auf diese Nachricht — wir sind für dich da.',
    infoBox: 'Es muss nicht perfekt sein, du kannst diese Informationen später immer noch ändern.',
    createAccountTitle: 'Erstelle dein Konto',
    createAccountSubtitle: 'Letzter Schritt: Erstelle dein Konto, um deine Registrierung abzuschließen.',
    createAccountSubtitle2: 'Diese Informationen ermöglichen es dir, dich anzumelden und dein Profil zu verwalten.',
    section1Title: 'Allgemeine Informationen',
    section1Subtitle: 'Einige Informationen, um dein Profil vorzustellen.',
    profileName: 'Profilname',
    profileNamePlaceholder: 'Z.B: Aya Braid Studio',
    country: 'Land',
    selectCountry: 'Land auswählen',
    noCountryFound: 'Kein Land gefunden',
    mainCity: 'Hauptstadt',
    mainCityPlaceholder: 'Z.B: Paris',
    canTravel: 'Ich kann zum Zuhause der Kundin fahren',
    addCity: 'Eine bediente Stadt hinzufügen',
    presentation: 'Präsentation',
    presentationPlaceholder: 'Erkläre, wie du arbeitest, was du anbietest, deine Leistungen…',
    section2Title: 'Kontaktinformationen',
    section2Subtitle: 'Wie können Kundinnen dich kontaktieren?',
    primaryContact: 'Primäres soziales Netzwerk',
    selectPrimary: 'Auswählen',
    primaryContactHelp: 'Das primäre Netzwerk wird auf deiner Karte angezeigt. Deine anderen Kontaktmöglichkeiten sind auf deiner Profilseite sichtbar.',
    section3Title: 'Fotos',
    section3Subtitle: 'Füge ein Porträt und einige Arbeitsproben hinzu (max. 6).',
    profilePhoto: 'Profilfoto',
    addPhoto: 'Foto hinzufügen',
    remove: 'Entfernen',
    section4Title: 'Welche Dienstleistungen bietest du an?',
    section4Subtitle: 'Wähle alle entsprechenden Dienstleistungen aus.',
    loadingCategories: 'Kategorien werden geladen…',
    username: 'Benutzername',
    usernamePlaceholder: 'Z.B: marie_braids78',
    email: 'E-Mail',
    emailPlaceholder: 'Z.B: marie@example.com',
    password: 'Passwort',
    passwordPlaceholder: 'Mindestens 6 Zeichen',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Gib dein Passwort erneut ein',
    cancel: 'Abbrechen',
    next: 'Weiter',
    previous: 'Zurück',
    submitting: 'Wird gesendet…',
    continue: 'Fortfahren',
    validateProfile: 'Mein Profil validieren',
    creating: 'Wird erstellt…',
    createAccountAndJoin: 'Mein Konto erstellen und dem Verzeichnis beitreten',
    confirmCancel: 'Bist du sicher, dass du deine Registrierung abbrechen möchtest?',
    progressStep1: 'Profil erstellen',
    progressStep2: 'Konto erstellen',
    progressStep3: 'Bestätigung',
    progressStepAria: 'Schritt {step}: {label}',
    validation: {
      pleaseCompleteFields: 'Bitte fülle die folgenden Felder aus: {fields}.',
      atLeastOneService: 'Mindestens eine Leistung',
      atLeastThreePhotos: 'Mindestens 3 Fotos deiner Arbeiten',
      completeProfileFirst: 'Bitte vervollständige zuerst dein Profil (Schritt 1), bevor du dein Konto erstellst. Möglicherweise hast du die Konto-Seite direkt aufgerufen.',
      atLeastOneContact: 'Mindestens eine Kontaktangabe',
      primaryContactRequired: 'Primäres soziales Netzwerk',
      confirmPasswordLabel: 'Passwort bestätigen',
    },
    errorLoadCategories: 'Kategorien konnten nicht geladen werden.',
    errorCountryNotSupported: 'Dieses Land wird noch nicht unterstützt. Bitte wähle eine Stadt in Europa oder im frankophonen Afrika.',
    errorImagesOnlyProfile: 'Nur Bilder sind für das Profilfoto erlaubt.',
    errorImagesOnlyGallery: 'Nur Bilder sind für die Galerie erlaubt.',
    errorProfileCreation: 'Fehler beim Erstellen des Profils. Bitte versuche es erneut.',
    creatingAccount: 'Dein Konto wird erstellt...',
    errorEmailVerification: 'Fehler bei der E-Mail-Verifizierung. Bitte versuche es erneut.',
    errorGeneric: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    errorFormNotFound: 'Fehler: Formular nicht gefunden. Bitte lade die Seite neu.',
    errorOccurred: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    contactFields: {
      instagram: 'Instagram',
      instagramPlaceholder: 'Benutzername',
      tiktok: 'TikTok',
      tiktokPlaceholder: 'TikTok-Benutzername',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: 'WhatsApp-Telefonnummer',
      phone: 'Telefon',
      phonePlaceholder: 'Telefonnummer',
      externalLink: 'Externer Link',
      externalLinkPlaceholder: 'Z.B: Calendly-Link',
    },
  },
  // Footer
  footer: {
    navigation: 'Navigation',
    home: 'Home',
    hairstylists: 'Friseurinnen',
    posts: 'Posts',
    information: 'Informationen',
    about: 'Über uns',
    faq: 'FAQ',
    contact: 'Kontakt',
    legal: 'Impressum',
    refund: 'Rückerstattungsrichtlinie',
    followUs: 'Folge uns',
    instagram: 'Instagram',
    allRightsReserved: 'Alle Rechte vorbehalten',
  },
  // Legal Page - Simplified version, full translations can be added later
  legal: {
    title: 'Impressum',
    lastUpdate: 'Letzte Aktualisierung: 4. Dezember 2025',
    editor: {
      title: '1. Herausgeber der Website',
      name: 'Chérie, Coiffer ?',
      editor: 'Projekt herausgegeben von:',
      editorName: 'Christelle Kabemba',
      country: 'Belgien',
      email: 'E-Mail:',
    },
    hosting: {
      title: '2. Hosting',
      text: 'Die Website wird gehostet von:',
      provider: 'Firebase Hosting – Google LLC',
      address: '1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.',
    },
    purpose: {
      title: '3. Zweck der Website',
      description: '<strong>Chérie, Coiffer ?</strong> ist ein digitales Verzeichnis, das die Suche nach afro Friseurinnen in Belgien und anderswo erleichtert. Das Ziel ist es, an einem Ort zusammenzubringen:',
      items: [
        'Friseurinnen-Profile',
        'ihre öffentlichen Instagram / TikTok-Konten',
        'ihre öffentlich sichtbaren Dienstleistungen',
        'ihre nicht-privaten Standortinformationen',
      ],
      goal: 'Die Website zielt darauf ab, die Sichtbarkeit von Friseurinnen zu verbessern und das Leben der Kundinnen zu vereinfachen.',
    },
    profiles: {
      title: '4. Erstellung von Friseurinnen-Profilen',
      public: {
        title: '4.1 Aus öffentlichen Informationen generierte Profile',
        text: 'Um es Kundinnen zu erleichtern, aktive Friseurinnen in Belgien zu entdecken, können einige Profile aus <strong>öffentlichen und frei zugänglichen</strong> Informationen erstellt werden, wie z.B.:',
        items: [
          'Instagram öffentlicher Pseudonym oder Name',
          'öffentliches Profilfoto',
          'öffentlich sichtbare Dienstleistungen',
          'angegebene Stadt oder Servicebereich',
        ],
        privacy: 'Keine privaten Informationen (persönliche Adresse, private Nummer, Gespräche, etc.) werden gesammelt oder veröffentlicht.',
      },
      rights: {
        title: '4.2 Recht auf Änderung, Löschung und Verwaltung des Profils',
        text: 'Jede Friseurin kann jederzeit:',
        items: [
          'die <strong>sofortige Löschung</strong> ihres Profils anfordern,',
          'die <strong>Änderung</strong> ihrer Informationen anfordern,',
          'ihr Profil <strong>beanspruchen</strong>, um es persönlich zu verwalten.',
        ],
        contact: 'Dazu senden Sie einfach eine Nachricht an die folgende Adresse:',
        deletion: 'Die Löschung wird so schnell wie möglich durchgeführt, ohne dass eine Begründung erforderlich ist.',
      },
    },
    accounts: {
      title: '5. Benutzerkonten (Kundinnen und Friseurinnen)',
      text: 'Benutzerinnen können ein Konto erstellen, um:',
      items: [
        'ein professionelles Profil zu verwalten,',
        'Friseurinnen zu Favoriten hinzuzufügen,',
        'Fragen im Forum zu stellen,',
        'Bewertungen zu hinterlassen (wenn die Option aktiviert ist).',
      ],
      responsibility: 'Jede Benutzerin bleibt für die von ihr veröffentlichten Informationen verantwortlich.',
    },
    data: {
      title: '6. Datenerfassung und -verarbeitung',
      text1: 'Die einzigen automatisch erfassten Daten sind anonym und statistisch (über Google Analytics oder Äquivalent). Keine sensiblen Daten werden erfasst.',
      text2: 'Keine Daten werden verkauft oder übertragen.',
    },
    gdpr: {
      title: '7. Ihre Rechte (DSGVO)',
      text: 'Gemäß DSGVO haben Sie das Recht auf:',
      items: [
        'Zugang zu Ihren Daten,',
        'Berichtigung,',
        'Widerspruch,',
        'Löschung ("Recht auf Vergessenwerden").',
      ],
      contact: 'Für jede Anfrage:',
    },
    intellectual: {
      title: '8. Geistiges Eigentum',
      text: 'Das Design, das Logo, die Texte und der Code der Website gehören Chérie, Coiffer ?. Instagram-Profilfotos gehören ihren jeweiligen Eigentümern und werden nur als <strong>nicht-kommerzielle Miniaturansichten</strong> verwendet, um auf ihre öffentlichen Seiten zu verlinken.',
    },
    liability: {
      title: '9. Haftung',
      text: 'Chérie, Coiffer ? ist nicht verantwortlich für:',
      items: [
        'die Qualität der von Friseurinnen erbrachten Dienstleistungen,',
        'falsche Informationen zu Profilen aus öffentlichen Quellen,',
        'Entscheidungen, die von Kundinnen getroffen werden.',
      ],
    },
    contact: {
      title: '10. Kontakt',
      text: 'Für jede Frage oder Anfrage bezüglich Ihrer Daten oder Ihres Profils:',
    },
  },
  // FAQ Page - Simplified version
  faq: {
    title: 'Häufig gestellte Fragen (FAQ)',
    lastUpdate: 'Letzte Aktualisierung:',
    pro: {
      title: '1. PRO-Abonnement',
      whatIs: {
        title: '1.1 Was ist das PRO-Abonnement?',
        text: 'Das PRO-Abonnement ist ein monatliches Abonnement von <strong>9,99 €/Monat</strong>, das Dienstleistern (Friseurinnen, Nageldesignerinnen, Make-up-Artistinnen, Wimpernstylistinnen) ermöglicht, von Premium-Funktionen auf Chérie Coiffer zu profitieren.',
      },
      benefits: {
        title: '1.2 Was sind die Vorteile des PRO-Abonnements?',
        text: 'PRO-Dienstleister profitieren von:',
        items: [
          'Erhöhte Sichtbarkeit in den Suchergebnissen',
          'Prioritäre Anzeige in den Listen',
          'Sichtbarer "PRO"-Status auf ihrem Profil',
          'Zugang zu detaillierten Statistiken',
        ],
      },
      subscribe: {
        title: '1.3 Wie abonniere ich das PRO-Abonnement?',
        text: 'Um das PRO-Abonnement zu abonnieren, müssen Sie zuerst ein Dienstleister-Profil auf Chérie Coiffer erstellen. Sobald Ihr Profil erstellt wurde, werden Sie zur Zahlungsseite weitergeleitet, wo Sie das PRO-Abonnement auswählen und die Zahlung über Stripe vornehmen können.',
      },
      cancel: {
        title: '1.4 Wie kann ich mein PRO-Abonnement kündigen?',
        text: 'Um Ihr PRO-Abonnement zu kündigen, kontaktieren Sie uns bitte per E-Mail unter',
        text2: 'und geben Sie Ihre Kündigungsanfrage an. Wir werden Ihre Anfrage so schnell wie möglich bearbeiten.',
        important: 'Wichtig:',
        importantText: 'Die Kündigung wird am Ende des aktuellen Abrechnungszeitraums wirksam. Sie profitieren weiterhin von den PRO-Vorteilen bis zum Ende dieses Zeitraums.',
      },
      paymentFailed: {
        title: '1.5 Was passiert, wenn meine Zahlung fehlschlägt?',
        text: 'Bei Zahlungsausfall erhalten Sie eine Benachrichtigungs-E-Mail. Sie haben eine Gnadenfrist von 7 Tagen, um Ihre Zahlungsmethode zu aktualisieren. Wenn die Zahlung nicht innerhalb dieser Frist erfolgt, wird Ihr PRO-Abonnement automatisch deaktiviert und Ihr Konto wechselt zurück in den kostenlosen (FREE) Modus.',
      },
      refund: {
        title: '1.6 Kann ich eine Rückerstattung erhalten?',
        text: 'Abonnements werden monatlich abgerechnet. Bei Kündigung profitieren Sie weiterhin von den PRO-Vorteilen bis zum Ende des aktuellen Abrechnungszeitraums. Für den verbleibenden Zeitraum wird keine teilweise Rückerstattung vorgenommen.',
      },
    },
    profile: {
      title: '2. Profilerstellung und -verwaltung',
      create: {
        title: '2.1 Wie erstelle ich ein Dienstleister-Profil?',
        text: 'Um ein Dienstleister-Profil zu erstellen, klicken Sie im Menü auf "Ich bin Dienstleister", wählen Sie Ihren Dienstleistungstyp (Haare, Nägel, Make-up, Wimpern) und folgen Sie dann den Schritten des Registrierungsformulars.',
      },
      edit: {
        title: '2.2 Kann ich mein Profil nach der Erstellung bearbeiten?',
        text: 'Ja, Sie können Ihr Profil jederzeit bearbeiten, indem Sie sich in Ihr Konto einloggen und auf die Profilbearbeitungsseite zugreifen.',
      },
      delete: {
        title: '2.3 Wie lösche ich mein Profil?',
        text: 'Um Ihr Profil zu löschen, kontaktieren Sie uns unter',
        text2: 'Die Löschung wird so schnell wie möglich durchgeführt.',
      },
    },
    search: {
      title: '3. Suche und Filter',
      howTo: {
        title: '3.1 Wie suche ich nach einem Dienstleister?',
        text: 'Verwenden Sie die Suchleiste oben auf der Seite, um nach Name, Dienstleistungstyp oder Stadt zu suchen. Sie können auch erweiterte Filter verwenden, um Ihre Suche zu verfeinern.',
      },
      city: {
        title: '3.2 Wie funktioniert die Stadtfilterung?',
        text: 'Die Stadtfilterung zeigt nur Dienstleister an, die diese Stadt in ihrem Profil angegeben haben (Hauptstadt oder Reise-Städte). Dienstleister, die reisen können, aber Ihre Stadt nicht angegeben haben, werden nicht in den Ergebnissen angezeigt.',
      },
    },
    account: {
      title: '4. Benutzerkonto',
      create: {
        title: '4.1 Wie erstelle ich ein Konto?',
        text: 'Sie können ein Konto erstellen, indem Sie auf "Anmelden" und dann auf "Registrieren" klicken. Sie können ein Konto als Kundin oder direkt als Dienstleisterin erstellen.',
      },
      forgotPassword: {
        title: '4.2 Ich habe mein Passwort vergessen',
        text: 'Klicken Sie auf "Anmelden" und dann auf "Passwort vergessen" und folgen Sie den Anweisungen, um Ihr Passwort zurückzusetzen.',
      },
      delete: {
        title: '4.3 Wie lösche ich mein Konto?',
        text: 'Sie können Ihr Konto von der Seite "Kontoverwaltung" in den Einstellungen Ihres Profils löschen. Diese Aktion ist unwiderruflich und löscht alle Ihre Daten.',
      },
    },
    reviews: {
      title: '5. Bewertungen und Bewertungen',
      howTo: {
        title: '5.1 Wie hinterlasse ich eine Bewertung?',
        text: 'Um eine Bewertung zu hinterlassen, müssen Sie angemeldet sein und das Profil des Dienstleisters angesehen haben. Bewertungen müssen respektvoll sein und auf einer echten Erfahrung basieren.',
      },
      edit: {
        title: '5.2 Kann ich meine Bewertung bearbeiten oder löschen?',
        text: 'Ja, Sie können Ihre Bewertungen von Ihrer Profilseite im Abschnitt "Meine Bewertungen" bearbeiten oder löschen.',
      },
    },
    support: {
      title: '6. Kontakt und Support',
      contact: {
        title: '6.1 Wie kann ich Sie kontaktieren?',
        text: 'Für jede Frage, Anfrage oder Problem können Sie uns per E-Mail unter',
      },
      response: {
        title: '6.2 Antwortzeit',
        text: 'Wir bemühen uns, alle Anfragen innerhalb von 48 Geschäftsstunden zu beantworten.',
      },
    },
  },
  // About Page - Simplified version
  about: {
    title: 'Über uns',
    lastUpdate: 'Letzte Aktualisierung: 4. Dezember 2025',
    mission: {
      title: 'Unsere Mission',
      text1: '<strong>Chérie, Coiffer ?</strong> ist eine Plattform, die die Suche nach afro Friseurinnen in Belgien (und bald anderswo) erleichtert. Die Idee ist einfach: alle Friseurinnen, die auf Instagram, TikTok oder anderswo aktiv sind, an einem Ort zusammenzubringen, um Kundinnen zu helfen, genau das zu finden, was sie suchen, ohne stundenlang in sozialen Netzwerken zu stöbern.',
      text2: 'Ob Sie jemanden in Ihrer Nähe, eine Spezialistin für eine Art von Zöpfen oder einfach Haarinspirationen suchen, unser Ziel ist es, diese Suche einfacher, klarer und zugänglicher zu gestalten.',
    },
    why: {
      title: 'Warum dieses Projekt?',
      text1: 'Nach mehreren Jahren im Ausland kehrte ich zurück, um in Belgien zu leben, und erkannte schnell ein Problem: eine zuverlässige Friseurin zu finden war extrem kompliziert geworden.',
      text2: 'Alles läuft über Instagram und TikTok, aber wenn Sie das richtige <strong>@</strong> nicht kennen, ist es leicht, eine talentierte Friseurin zu verpassen… manchmal sogar die, die nur zwei Straßen von Ihnen entfernt wohnt.',
      text3: 'Als Digital-Enthusiastin habe ich beschlossen, ein Tool zu erstellen, das diese Informationen auf einfache, klare und transparente Weise zentralisiert.',
    },
    profiles: {
      title: 'Wie werden Profile erstellt?',
      text1: 'Um die Plattform sofort nützlich zu machen, werden einige Friseurinnen-Profile aus <strong>öffentlichen</strong> Informationen erstellt, die in ihren sozialen Netzwerken sichtbar sind (Pseudonym, öffentliche Fotos, angezeigte Dienstleistungen, etc.).',
      text2: '<strong>Jede Friseurin behält die vollständige Kontrolle über ihr Profil:</strong>',
      items: [
        'ihr Profil beanspruchen, um es selbst zu verwalten;',
        'Informationsänderungen anfordern;',
        'sofortige Profillöschung anfordern, ohne Begründung.',
      ],
      text3: 'Das Ziel ist niemals, Instagram-Seiten zu ersetzen: einfach, sie leichter auffindbar zu machen.',
    },
    name: {
      title: 'Warum "Chérie, Coiffer ?"',
      text1: 'Der Name ist ein Hinweis auf einen bekannten Satz in der Gemeinschaft:',
      quote: '« Mein Schatz, komm, ich mache dir die Haare »',
      text2: 'typisch für Viertel wie Matongé, wo Friseurinnen Kundinnen ansprechen.',
      text3: 'Die Website spiegelt diesen Geist wider: ein warmer, zugänglicher Raum, der für uns gestaltet wurde.',
    },
    values: {
      title: 'Unsere Werte',
      items: [
        '<strong>Zugänglichkeit:</strong> allen zu ermöglichen, eine Friseurin leicht zu finden.',
        '<strong>Sichtbarkeit:</strong> talentierten Friseurinnen helfen, besser entdeckt zu werden.',
        '<strong>Transparenz:</strong> Profile können jederzeit geändert oder gelöscht werden.',
        '<strong>Einfachheit:</strong> eine klare Plattform ohne Komplikationen.',
      ],
    },
    contact: {
      title: 'Kontakt',
      text: 'Für jede Frage, um ein Profil zu ändern oder zu beanspruchen, oder um zusammenzuarbeiten:',
    },
  },
  // Services und Kategorien aus Firestore
  // Codes entsprechen den Codes in der Datenbank
  // Format: services.{CODE} oder categories.{CODE}
  // Beispiel: services.TRESSES_CORNBROWS = "Cornrows"
  // Wenn eine Übersetzung nicht existiert, wird das französische Label aus der DB als Fallback verwendet
  services: {
    // Übersetzungen werden nach Bedarf hinzugefügt
    // Vorerst werden französische Labels aus der DB als Fallback verwendet
  },
  categories: {
    // Übersetzungen werden nach Bedarf hinzugefügt
    // Vorerst werden französische Labels aus der DB als Fallback verwendet
  },
};
